import { render, staticRenderFns } from "./StatisticsGraphInfo.vue?vue&type=template&id=bac74ca4"
import script from "./StatisticsGraphInfo.vue?vue&type=script&lang=js"
export * from "./StatisticsGraphInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports